// ChatGPT Ads (OpenAI) Measurement Pixel – „csak hirdetésből érkezők” üzemmód
// Docs: https://developers.openai.com/ads/measurement-pixel
//
// Szabályok:
// - csak marketing hozzájárulással ÉS hirdetéses attribúcióval (oppref URL-paraméter vagy __oppref süti) töltődik be
// - csak registration_completed és lead_created megy ki, { type: 'customer_action' } + { opt_out: true } adattal
// - az init hívásba soha nem kerül `user` objektum (személyes adat)

export const OPENAI_ADS_PIXEL_ID = process.env.NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID || '';
export const OPENAI_ADS_PIXEL_DEBUG = process.env.NEXT_PUBLIC_OPENAI_ADS_PIXEL_DEBUG === 'true';
export const OPENAI_ADS_PIXEL_SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

const OPPREF_PARAM = 'oppref';
const OPPREF_COOKIE = '__oppref';
const ALLOWED_EVENTS = ['registration_completed', 'lead_created'];

let isPixelActive = false;

export function setOpenAiAdsPixelActive(active) {
    isPixelActive = !!active;
}

// Csak olvasunk: hozzájárulás előtt az oppref-et sehova nem mentjük el
export function hasOpenAiAdsAttribution() {
    if (typeof window === 'undefined') return false;

    const oppref = new URLSearchParams(window.location.search).get(OPPREF_PARAM);
    if (oppref && oppref.trim() !== '') return true;

    return document.cookie
        .split(';')
        .some((part) => {
            const [name, ...rest] = part.trim().split('=');
            return name === OPPREF_COOKIE && rest.join('=') !== '';
        });
}

// A hivatalos snippet queue-stubja: a hívások sorba kerülnek, amíg az SDK be nem töltődik
export function ensureOaiq() {
    if (typeof window === 'undefined') return null;

    if (typeof window.oaiq !== 'function') {
        const queue = function () {
            queue.q.push(arguments);
        };
        queue.q = [];
        window.oaiq = queue;
    }

    return window.oaiq;
}

export function measureOpenAiAdsEvent(eventName) {
    if (!OPENAI_ADS_PIXEL_ID || !isPixelActive || !ALLOWED_EVENTS.includes(eventName)) return false;
    if (typeof window === 'undefined' || typeof window.oaiq !== 'function') return false;

    // A pixel semmilyen hibája nem akaszthatja meg a hívó sikeres ágát (regisztráció, ajánlatkérés)
    try {
        window.oaiq('measure', eventName, { type: 'customer_action' }, { opt_out: true });
        return true;
    } catch (_) {
        return false;
    }
}
